import { useAppContext } from '.';
import { hasLogoType } from '../utilities';
import { useDeepEffect } from './useDeepEffect';

import type { CourseType } from '../api';

const toArray = (course: null | CourseType | CourseType[]) => {
  return Array.isArray(course) ? course : course ? [course] : [];
};

export const useLogo = (course: null | CourseType | CourseType[]) => {
  const { setLogoType } = useAppContext();

  useDeepEffect(() => {
    const data = toArray(course);
    if (!data.length) return;

    const logoType: LogoType = data.some(c => hasLogoType(c))
      ? 'estate'
      : 'default';
    setLogoType(logoType);
  }, [course]);
};
